/**
 * @file: This file sorts names and tests a name against a search.
 *
 * The catalogue of Compose sorts every list by name, and the report searches
 * the media of a window. Both need the same order and the same test, so an
 * operator gets one behaviour on both pages.
 */

/**
 * One collator for the whole page. A new Intl.Collator for every comparison is
 * the slow way to sort, and every list here is sorted by name.
 */
const NAME_ORDER = new Intl.Collator(undefined, { sensitivity: 'base' })

/**
 * Compare two names, without regard to case or accent.
 *
 * @param {string} a - The first name
 * @param {string} b - The second name
 * @returns {number} A value for Array.prototype.sort
 */
const compareNames = (a, b) => NAME_ORDER.compare(a || '', b || '')

/**
 * A test for one name against what the operator typed.
 *
 * The needle is prepared once, because every media of the library is tested
 * against the same one on every keystroke.
 *
 * @param {string} search - What the operator typed
 * @returns {Function} A test that takes a media and gives true or false
 */
function nameMatcher (search) {
  const needle = (search || '').trim().toLowerCase()

  return needle
    ? media => (media.name || '').toLowerCase().includes(needle)
    : () => true
}

export { compareNames, nameMatcher }
